import React from "react";
import { LayerIcon } from "../comp/LayerIcon";
import { Icon } from "../comp/Icon";

export class RightPanel extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {

        // icons for each layer
        var layers = [];

        this.props.layers.map((item, i) => {
            layers.push(
                <LayerIcon 
                    section={item.section} 
                    active={(i == this.props.active)}
                    info={item} 
                    key={i} index={i} 
                    remove={this.props.remove}
                    up={this.props.up}
                    down={this.props.down}
                    edit={this.props.edit}
                    select={this.props.select}
                />
            );
        });


        if(layers.length == 0) {
            layers.push(
                <span className="error" key={0}>No layers</span>
            );
        }


        return (
            <div className="panel layers">
                <h1>Layers</h1>

                <div className="buttons main">
                    <button onClick={this.props.reset}> <Icon type="fa-trash" /> </button>
                </div>

                {layers}
            </div>
        );
    }
}


RightPanel.defaultProps = {
    layers: []
};
